var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 13100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 12C0 18.6269 5.37215 24 11.999 24C18.6259 24 23.9981 18.6269 23.9981 12C23.9981 5.37312 18.6259 0 11.999 0C5.37215 0 0 5.37312 0 12Z",
    fill: "#FFCB05"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 13099"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.2914 12.0826C23.2914 14.6445 18.2557 16.7212 12.0448 16.7212C5.83259 16.7212 0.796875 14.6445 0.796875 12.0826C0.796875 9.52065 5.83259 7.44531 12.0448 7.44531C18.2557 7.44531 23.2914 9.52065 23.2914 12.0826Z",
    fill: "#00678F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.83594 14.372L5.99915 9.7334H7.85763V12.4349L9.07934 9.7334H10.9976L9.83576 14.372H8.61405L9.31065 11.378L7.85763 14.372H6.87123V11.378L6.11348 14.372H4.83594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.375 14.4308L11.5492 13.7847H12.8865L12.711 14.4308H11.375Z",
    fill: "#ED1D24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.3672 14.372L15.5291 9.7334H16.8664L17.4487 12.2009L18.0868 9.7334H19.3072L18.1453 14.372H16.8664L16.227 11.8473L15.5876 14.372H14.3672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M11.3693 9.7334L11.0781 10.9087H12.2998L11.6418 13.4573H12.9778L13.6372 10.9087H14.8576L15.1474 9.7334H11.3693Z",
    fill: "#FFCB05"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtn);
export default __webpack_public_path__ + "static/media/mtn.faca38705c1c87421d22cfed7503566b.svg";
export { ForwardRef as ReactComponent };